import * as Linking from "expo-linking";

export class ExpoExternalLink {
    async goTo(url) {
        await Linking.openURL(url)
    }
}